import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { Button, Snackbar } from '@mui/material';
import { Card } from 'react-bootstrap';
import { MdDesignServices } from "react-icons/md";
const ServiceForm = () => {
    const { register, handleSubmit, setValue, reset, formState: { errors } } = useForm();
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success',
    });

    const [services, setServices] = useState([]); // Store existing services
    const [editingService, setEditingService] = useState(null); // Track the service being edited

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    // Fetch existing services from backend
    useEffect(() => {
        fetchServices();
    }, []);

    const fetchServices = async () => {
        try {
            const response = await axios.get('https://zoomautos.co.uk/api/moveservices', {
                              params: {
                _t: new Date().getTime(), // Add timestamp to bypass cache
              },
            
            });
            setServices(response.data);
        } catch (error) {
            console.error('Error fetching services:', error);
        }
    };

    const onSubmit = async (data) => {
        try {
            if (editingService) {
                // Update existing service
                await axios.put(`https://zoomautos.co.uk/api/moveservices/${editingService._id}`, data);
                setSnackbar({ open: true, message: 'Service updated successfully!', severity: 'success' });
            } else {
                // Add new service
                await axios.post('https://zoomautos.co.uk/api/moveservices', { formType: 'WhyUSForm', ...data });
                setSnackbar({ open: true, message: 'Service added successfully!', severity: 'success' });
            }

            fetchServices(); // Refresh service list
            reset(); // Clear form
            setEditingService(null);
        } catch (error) {
            console.error('Error submitting form:', error);
            setSnackbar({ open: true, message: 'Failed to submit service', severity: 'error' });
        }
    };

    const handleEdit = (service) => {
        setEditingService(service);
        setValue('description', service.description); // Fill form with existing data
    };

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this service?')) {
            try {
                await axios.delete(`https://zoomautos.co.uk/api/moveservices/${id}`);
                setSnackbar({ open: true, message: 'Service deleted successfully!', severity: 'success' });
                fetchServices(); // Refresh service list
            } catch (error) {
                console.error('Error deleting service:', error);
                setSnackbar({ open: true, message: 'Failed to delete service', severity: 'error' });
            }
        }
    };

    return (
        <>
        <div className='overalls'>
            <h1 style={{ marginTop: '100px' }}>Manage Services</h1>
            <div className="adminaddform-container" style={{ marginBottom: '50px' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-row">
                        <div className="form-group">
                            <h3>Service Description</h3>
                            <textarea
                                {...register('description', { required: 'Description is required' })}
                                placeholder="Enter service description"
                                style={{ width: '100%' }}
                                rows={4}
                            />
                            {errors.description && <p className="error-message">{errors.description.message}</p>}
                        </div>
                    </div>
                    <div className="form-row" style={{ display: 'flex', justifyContent: 'center' }}>
                        <button type="submit" className="contact-button" style={{ width: '50%' }}>
                            {editingService ? 'Update Service' : 'Add Service'}
                        </button>
                    </div>
                </form>
            </div>

            <h2>Existing Services</h2>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '20px', background: 'white', marginTop:'20px'}}>
      
      {services.map((service, index) => (
        <Card
          key={index}
          style={{
            width: '18rem',
            backgroundColor: 'white',
            boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.09)',
            padding: '2rem',
            position: 'relative',
            overflow: 'hidden',
            borderRadius: '8px',
            border: '4px solid #7C3AED',
            minHeight: '30rem',
            display: 'flex',
            flexDirection: 'column',
            marginBottom: '20px'
          }}
        >
          <div
            style={{
              width: '6rem',
              height: '6rem',
              backgroundColor: '#7C3AED',
              borderRadius: '50%',
              position: 'absolute',
              top: '-30px',
              right: '-30px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <p style={{ color: 'white', fontSize: '1.5rem' }}>{index + 1}</p>
          </div>
          <div style={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <MdDesignServices size={48} color="#7C3AED" />
          </div>
          <div style={{ flexGrow: 1, textAlign: 'center' }}>
            <Card.Text style={{ color: '#FFFFFF', fontSize: '0.875rem' }}>
              {service.description}
            </Card.Text>
          </div>
          <button onClick={() => handleEdit(service)} style={{ marginLeft: '10px' }}>Edit</button>
                        <button onClick={() => handleDelete(service._id)} style={{ marginLeft: '10px', color: 'red' }}>Delete</button>
        </Card>
      ))}
    </div>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={handleCloseSnackbar}
                message={snackbar.message}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                action={
                    <Button color="inherit" onClick={handleCloseSnackbar}>
                        Close
                    </Button>
                }
            />
             </div>
        </>
    );
};

export default ServiceForm;
